import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const CompetitionHotelForm = (strings: any): FormModel[] => {
  return [
    {
      label: strings.sales_management_branch_competitions_hotel_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'hotelName',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 6 },
      required: true,
    },
    {
      label: strings.sales_management_branch_competitions_reason,
      value: '',
      typeValue: 'textarea',
      type: 'text',
      placeholder: '',
      field: 'reason',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      required: true,
      responsive: { xs: 12 },
      rows: 2,
      multiline: true,
      size: 'medium',
      variant: 'outlined',
    },
    {
      label: strings.sales_management_branch_competitions_column_fit_potential,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'fitRoomNights',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 6 },
      required: false,
    },
    {
      label: strings.sales_management_branch_competitions_column_mice_potential,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'miceNights',
      responsive: { xs: 6 },
      required: false,
      validators: [],
    },
  ];
};
